module.exports = __webpack_public_path__ + "static/media/docs-image-01.f8c19f13.png";